export const UNINITIALISED = 'UNINITIALISED';
export const FETCHING = 'FETCHING';
export const COMPLETE = 'COMPLETE';
export const OUT_OF_DATE = 'OUT_OF_DATE';
